export default __webpack_public_path__ + "static/media/left-arrow.fe72d92c.svg";